export const environment = {
  backEnd: import.meta.env.VITE_BACKEND_URL,
  production: true,
};
export const googleApiKey = 'AIzaSyCvvDZ7DaL1Tzk_XRrTAld7XDw07YpUizU';
export const stripeApiKey = import.meta.env.VITE_STRIPE_API_KEY;
export const termsUrl = import.meta.env.VITE_TERMS_URL;
export const privacyUrl = import.meta.env.VITE_PRIVACY_URL;
export const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
export const publicCustomer = import.meta.env.VITE_PUBLIC_CUSTOMER;
